<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">示例名称：</span>
                <a-input placeholder="请输入示例名称" class="seachs" v-model="seach.name"/>
            </div>
          <div class="seachList"><span class="name">所属板块：</span>
            <a-select v-model="seach.type" class="seachs" placeholder="请选择" allowClear>
              <a-select-option :value="item.id" :key="item.id" v-for="item in seachList">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
            <div class="seachList  ">
                <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                    查询
                </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>
      <a-button class="top_btn" type="primary" @click="listOrder()"  > 排序</a-button>
      <a-button class="top_btn" type="primary" @click="()=>{  visible = true; title='添加内容示例' }"  > 添加
      </a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" >
             <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')" />
      </span>
            <span slot="action" slot-scope="text, record">

        <a @click="(record)=>{visible = true;  title=' 编辑内容示例'; editId=text.id ; }" >编辑</a>
    <a-divider type="vertical"/>
          <a-popconfirm
              title="此操作将永久删除, 是否继续?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirm(record)"
              @cancel="()=>{}"
          >
            <a >删除</a>
        </a-popconfirm>
      </span>
        </a-table>
        <ArticleForm :visible="visible" :title="title" :editId="editId" :seachList='seachList'
                     @changVisible=" () => { this.visible = false;this.editId=''; this.getList()}  "/>

    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import ArticleForm from "./components/articleForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [  {
      title: "排序",
      dataIndex: "list_order",
      key: "list_order",
      width: "100px",
      scopedSlots: {customRender: "list_order"}
    },
        {
            title: "示例名称",
            dataIndex: "name",
            ellipsis: true,width: "150px",
            key: "name"
        },
        {
            title: "所属板块",
            dataIndex: "type",
            ellipsis: true,width: "150px",
            key: "type",
        },
        {
            title: "内容",
            dataIndex: "content",
            ellipsis: true,
            key: "content"
        },



        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {
                resetSeachdata:true,
                fieldNames: {label: 'name', value: 'id', children: 'children'},
                visibleImg: false,
                tableImg: "",
                seachList:[],
                seach: {
                    name: "",
                  type: undefined
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/ai/contentExample"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
          this.getSeach()
        },
        components: {ArticleForm},
        computed: {

        },
        methods: {

            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },

            resetSeach() {
                this.loading = true
                this.seach = {
                  name: "",
                  type: undefined
                }
                this.resetSeachdata=false
                this.getList(1)
            },



    getSeach() {
      API.service.GET_SEACH().then(res => {
        this.seachList = res.data.data.types,
        this.selectedRowKeys=[]
        if(!this.resetSeachdata==true)this.seach.update_time=[]
        this.resetSeachdata=true
        this.loading = false
      })
    },

            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.seach))


                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data
                    this.resetSeachdata=true
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },

          listOrder() {
            let list_orders = []
            let sortListOrder = {id: "", list_order: ""}
            for (let i = 0; i < this.data.length; i++) {
              sortListOrder.id = this.data[i].id
              sortListOrder.list_order = this.data[i].list_order
              list_orders.push(sortListOrder)
              sortListOrder = {}
            }
            orderList(API.service.LIST_ORDER, list_orders).then(res => {
              if (res == true) {
                this.getList()
              }
            })
          },
          confirm(row) {
            removeById( API.service.DELE, row.id).then(res => {
              if (res == true) {
                this.getList()
              }
            })
          },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
